import { render, staticRenderFns } from "./FrequencyList.vue?vue&type=template&id=660a7905&scoped=true"
import script from "./FrequencyList.vue?vue&type=script&lang=js"
export * from "./FrequencyList.vue?vue&type=script&lang=js"
import style0 from "./FrequencyList.vue?vue&type=style&index=0&id=660a7905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a7905",
  null
  
)

export default component.exports